import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { environmentEvidence } from "@/lib/environmentEvidence";

const FALLBACK_VERSION = "3.5.0";

// Eine einzige Quelle: Aufbau/Code ist auf Preview und Live identisch.
// Nur Farbe und Text unterscheiden sich (Daten-Modus). Kompakt & dezent.
export default function EnvBadge() {
  const [version, setVersion] = useState(FALLBACK_VERSION);
  const [metadata, setMetadata] = useState({});

  useEffect(() => {
    api.get("/meta").then(({ data }) => { setMetadata(data || {}); if (data?.version) setVersion(data.version); }).catch(() => {});
  }, []);

  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const evidence = environmentEvidence(metadata, host);
  const production = evidence.environment === "production";
  const cfg = { label: evidence.label, dot: production ? "#A3E635" : "#F59E0B", text: production ? "#A3E635" : "#FBBF24" };

  return (
    <div data-testid="env-badge" data-env={evidence.environment}
      title="Umgebung anhand von Serverkonfiguration und Host; keine Bestätigung des Datenbestands"
      className="rounded-lg border border-white/10 bg-white/[0.025] px-2.5 py-1">
      <div className="flex items-center gap-2 leading-none">
        <span className="h-1.5 w-1.5 rounded-full shrink-0" style={{ backgroundColor: cfg.dot }} />
        <span className="text-[10.5px] font-bold tracking-wide truncate">
          <span data-testid="env-badge-label" style={{ color: cfg.text }}>{cfg.label}</span>
        </span>
      </div>
      <div className="text-[9px] text-gray-600 mt-0.5 pl-[14px]" data-testid="env-badge-version">Version v{version}</div>
    </div>
  );
}
